import { Theme, alpha } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { tableRowClasses } from '@mui/material/TableRow';

// ----------------------------------------------------------------------

export function table(theme: Theme) {
  return {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          position: 'relative',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          transition: 'background-color 0.2s ease',
          [`&.${tableRowClasses.selected}`]: {
            backgroundColor: alpha(theme.palette.primary.dark, 0.04),
            '&:hover': {
              backgroundColor: alpha(theme.palette.primary.dark, 0.08),
            },
          },
          // ✅ Hover cho toàn bộ row
          '&:hover:not(.MuiTableRow-head)': {
            backgroundColor: alpha(theme.palette.primary.main, 0.04),
          },
          '&:last-of-type': {
            [`& .${tableCellClasses.root}`]: {
              borderColor: 'transparent',
            },
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottomStyle: 'dashed',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '300px',
        },
        // ✅ Style riêng cho BODY cells (không phải header)
        body: {
          position: 'relative',
          transition: 'all 0.2s ease',
          // ✅ Hiển thị full text khi hover
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            cursor: 'pointer',
            overflow: 'visible',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            zIndex: 10,
            boxShadow: theme.shadows[4],
            // ✅ Tạo background layer
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: theme.palette.background.paper,
              zIndex: -1,
              boxShadow: theme.shadows[4],
              borderRadius: theme.shape.borderRadius,
            },
          },
        },
        head: {
          fontSize: 14,
          color: theme.palette.text.secondary,
          fontWeight: theme.typography.fontWeightSemiBold,
          backgroundColor: theme.palette.background.neutral,
          position: 'sticky', // ✅ Đảm bảo header sticky
          top: 0,
          zIndex: 100, // ✅ Header luôn ở trên cùng
        },
        stickyHeader: {
          backgroundColor: '#168ea6 !important',
          color: '#FFFFFF !important',
          backgroundImage: 'none',
          zIndex: 100, // ✅ Đảm bảo sticky header ở trên
        },
        paddingCheckbox: {
          paddingLeft: theme.spacing(1),
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          width: '100%',
        },
        toolbar: {
          height: 64,
        },
        actions: {
          marginRight: 8,
        },
        select: {
          paddingLeft: 8,
          '&:focus': {
            borderRadius: theme.shape.borderRadius,
          },
        },
        selectIcon: {
          right: 4,
          width: 16,
          height: 16,
          top: 'calc(50% - 8px)',
        },
      },
    },
  };
}